import { getCurrentGroupInformationStore } from 'owa-groups-shared-store/lib/CurrentGroupInformationStore';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('updateGroupCurrentInfoAction', (groupSmtpAddress: string) => {
    getCurrentGroupInformationStore().smtpAddress = groupSmtpAddress.toLowerCase();
});
